import React from "react";
import { Link } from "react-router-dom";

const ErrorPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-transparent text-white px-6 text-center">
      <div className="bg-white/10 backdrop-blur-md p-10 rounded-2xl shadow-xl border border-white/20 max-w-lg w-full">
        <h1 className="text-7xl font-extrabold text-yellow-300 drop-shadow mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-white mb-2">Oops! Page Not Found</h2>
        <p className="text-gray-300 mb-6">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-yellow-400 text-black font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-yellow-300 transition"
        >
          🔙 Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
